import $ from "jquery";

const locale = window.location.pathname.split("/")[1] || "en";

// Toggle sub-navigation bar on my portal click
$("a.subnavbar-toggle").click(function (event) {
  const isMobile = window.innerWidth < 1080;
  const closed =
    (isMobile && $(".sub-nav-bar").hasClass("d-none")) ||
    (!isMobile && $(".sub-nav-bar").hasClass("d-lg-none"));
  if (closed === true) {
    $(".sub-nav-bar").removeClass("d-none");
    $(".sub-nav-bar").removeClass("d-lg-none");
    $(".sub-nav-bar").addClass("d-flex");
    $(".sub-nav-bar").addClass("d-lg-flex");
  } else {
    $(".sub-nav-bar").addClass("d-none");
    $(".sub-nav-bar").addClass("d-lg-none");
    $(".sub-nav-bar").removeClass("d-flex");
    $(".sub-nav-bar").removeClass("d-lg-flex");
  }
});

$(".js-course-navigation-toggle").click(function () {
  const $this = $(this);
  $($(this).find(".course-navigation-icon")).toggleClass("active");
  $(".side-nav").toggleClass("expanded");
});

$(".js-collapse").on("show.bs.collapse hide.bs.collapse", function () {
  const $faIcon = $(this).prev().find("i");
  if ($faIcon.hasClass("fa-minus")) {
    $faIcon.addClass("fa-plus").removeClass("fa-minus");
  } else {
    $faIcon.addClass("fa-minus").removeClass("fa-plus");
  }
});

// Change active circle on carousel slide
const $carouselIndicators = $(".carousel-indicators");
$("#question-carousel").on("slide.bs.carousel", function (event) {
  const toIndex = event.to;
  const fromIndex = event.from;

  $($carouselIndicators.children()[fromIndex]).removeClass("active");
  $($carouselIndicators.children()[toIndex]).addClass("active");
});

// Resize input field for fill in the blanks questions
const $measureElement = $(".hidden-input-resize");
$(".fill-blank-input").each(function () {
  const $this = $(this);
  const handleInput = function () {
    $measureElement.text($this.val());
    $this.width($measureElement.width());
  };
  $this.on("input", handleInput);
  handleInput();
});

// Body scroller
const $body = $(document.body);
const topOfSitePixel = document.getElementById("top-of-site-pixel-anchor");
if (
  "IntersectionObserver" in window &&
  "IntersectionObserverEntry" in window &&
  "intersectionRatio" in window.IntersectionObserverEntry.prototype &&
  topOfSitePixel
) {
  let observer = new IntersectionObserver((entries) => {
    if (entries[0].boundingClientRect.y < 0) {
      $body.addClass("scrolled");
    } else {
      $body.removeClass("scrolled");
    }
  });
  observer.observe(topOfSitePixel);
}

let separateCoursesPrice = {
  "1": 0,
  "6": 0,
  "12": 0,
};
const $coursesOrderButton = $(".js-order-button");
const $separateCoursesCheckboxes = $(".js-course-checkbox");
const $packageCheckbox = $(".js-package-checkbox");
const handleCheckboxChange = function () {
  const $this = $(this);
  const price = $this.data("price");
  const duration = $this.data("duration");
  const isChecked = $this.prop("checked");
  const isPackageCheckbox = $this.hasClass("js-package-checkbox");
  const $parentForm = $this.parents("form");
  const $allCoursesCards = $parentForm.find(
    ".plans-and-pricing-card.js-course"
  );
  const $allPackagesCards = $parentForm.find(
    ".plans-and-pricing-card.js-package"
  );
  const $freeCourse = $parentForm.find(
    ".plans-and-pricing-card.js-free-in-full"
  );

  if (isChecked) {
    if (isPackageCheckbox) {
      $allCoursesCards.each(function () {
        let items = []
        $courseCheckbox = $(this).find("input[type=checkbox]");
        items.push({
          item_name: $courseCheckbox.data('name'),
          item_id: $courseCheckbox.val(),
          currency: 'EUR',
          discount: 0,
          price: $courseCheckbox.data('price'),
          item_variant: `${$courseCheckbox.data('duration')} month(s)`,
          item_brand: document.location.host,
        })
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "select_item",
          ecommerce: {
            items: items
          }
        });
      })

      const courseIds = $this.data("course-ids").split(",");
      $allCoursesCards.removeClass("active");
      $allCoursesCards.addClass("active");
      $freeCourse.find(".js-free").removeClass("d-none");
      $freeCourse.find(".js-paid").addClass("d-none");
      $parentForm
        .find("input[type=checkbox]")
        .prop("checked", false)
        .prop("disabled", false);

      $allCoursesCards
        .find(courseIds.map((id) => `input[value="${id}"]`).join(","))
        .prop("checked", true)
        .prop("disabled", true);
      $allPackagesCards
        .find("input[type=checkbox]")
        .prop("checked", false)
        .prop("disabled", false);
      $this.prop("disabled", false).prop("checked", true);
      separateCoursesPrice[duration] = price * 1;
    } else {
      separateCoursesPrice[duration] += price * 1;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "select_item",
        ecommerce: {
          items: [{
            item_name: $this.data('name'),
            item_id: $this.val(),
            currency: 'EUR',
            discount: 0,
            price: $this.data('price'),
            item_variant: `${$this.data('duration')} month(s)`,
            item_brand: document.location.host,
          }]
        }
      });
    }
    $this.closest(".plans-and-pricing-card").addClass("active");
  } else {
    $this.closest(".plans-and-pricing-card").removeClass("active");
    if (isPackageCheckbox) {
      $allPackagesCards.removeClass("active");
      $allCoursesCards.removeClass("active");
      $freeCourse.find(".js-paid").removeClass("d-none");
      $freeCourse.find(".js-free").addClass("d-none");
      $parentForm
        .find("input[type=checkbox]")
        .prop("checked", false)
        .prop("disabled", false);
      separateCoursesPrice[duration] = 0;
    } else separateCoursesPrice[duration] -= price * 1;
  }

  $parentForm
    .find(".js-order-button")
    .attr("disabled", separateCoursesPrice[duration] <= 0);
  let readablePrice = `${separateCoursesPrice[duration].toFixed(2)}`;
  readablePrice = readablePrice.replace(".", ",");
  const readablePriceParts = readablePrice.split(",");
  if (readablePriceParts[1] !== undefined) {
    if (readablePriceParts[1] === "00") {
      readablePrice = readablePrice.replace(",00", ",-");
    }
  } else {
    readablePrice += ",-";
  }

  $parentForm.find(".js-separate-courses-price").html(readablePrice);
};

$separateCoursesCheckboxes.on("change", handleCheckboxChange);
$packageCheckbox.on("change", handleCheckboxChange);
$coursesOrderButton.on("click", function (e) {
  e.preventDefault();
  const $this = $(this);
  $this.attr("disabled", true);
  try {
    const $parentForm = $this.parents("form");
    let paymentUrl = `/${locale}/purchase-courses`;
    let ids = [];
    let items = [];

    const totalPriceIncludingVat = parseFloat($parentForm.find(".js-separate-courses-price").text());

    $parentForm.find(".js-course-checkbox").map((index, checkbox) => {
      const $checkbox = $(checkbox);
      if ($checkbox.prop("checked")) {
        ids.push($checkbox.val());
        items.push({
          item_name: $checkbox.data('name'),
          item_id: $checkbox.val(),
          currency: 'EUR',
          discount: 0,
          price: $checkbox.data('price'),
          item_variant: `${$checkbox.data('duration')} month(s)`,
          item_brand: document.location.host,
        })
      };
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "EUR",
        value: totalPriceIncludingVat,
        items: items
      }
    });

    $parentForm.find(".js-package-checkbox").map((index, checkbox) => {
      const $checkbox = $(checkbox);
      if ($checkbox.prop("checked")) {
        ids = [$checkbox.val()];
        paymentUrl = `/${locale}/purchase`;
      }
    });
    paymentUrl += "/" + ids.join(",");
    paymentUrl += "/" + $(this).data("duration");
    localStorage.setItem('isPurchasing', 'true');
    console.log("Payment URL: ", paymentUrl);
    window.location.href = paymentUrl;
  } catch (e) {
    $this.attr("disabled", false);
    console.error("Error creating payment url: ", e);
  }
});

const $questionNavigation = $(".js-question-navigation");
if ($questionNavigation.length) {
  const questionIsCorrectArray = $questionNavigation.data(
    "questionsCorrectArray"
  );
  const $paginationList = $($questionNavigation[0]).find("ul.pagination");
  const $paginationListItems = $paginationList.children("li");
  $paginationListItems.map((index, listItem) => {
    const $listItem = $(listItem);
    const $anchor = $listItem.find("*");
    if ($anchor && $anchor[0] !== undefined) {
      const indexToCheck = $anchor[0].innerHTML - 1;
      if (indexToCheck in questionIsCorrectArray) {
        if (questionIsCorrectArray[indexToCheck]) {
          $anchor.addClass("bg-success");
          $anchor.addClass("text-white");
        } else if (questionIsCorrectArray[indexToCheck] !== null) {
          $anchor.addClass("bg-danger");
          $anchor.addClass("text-white");
        } else {
          $anchor.addClass("bg-warning");
          $anchor.addClass("text-white");
        }
      }
    }
  });
}

const $videoPlayButtons = $(".js-play-video-fullscreen");
if ($videoPlayButtons.length) {
  $videoPlayButtons.on("click", function (e) {
    e.preventDefault();
    const $this = $(this);
    $this.hide();
    const $videoElement = $this.siblings("video");
    const $thumbnailElement = $this.siblings("img");
    const $descriptionElement = $this.siblings("b");
    if ($thumbnailElement.length) {
      $thumbnailElement.removeClass("d-lg-inline");
      $thumbnailElement.hide();
    }
    if ($descriptionElement.length) {
      $descriptionElement.hide();
    }
    if ($videoElement.length) {
      $this.hide();
      $videoElement.removeClass("d-none");
      if (document.fullscreenEnabled) {
        $videoElement[0].requestFullscreen();
      }
      setTimeout(function () {
        $videoElement[0].play();
      }, 300);
    }
  });
}

// START Plan Select
const $planSelectCheckboxes = $(".js-plan-select");
const $courseSelectCards = $(".js-course-select-card");
const $checkoutButtonLink = $(".js-checkout-button-link");
const $planSelectRadios = $(".js-plan-select-radio");
if ($planSelectCheckboxes.length) {
  $planSelectCheckboxes.on("click", function (e) {
    $planSelectCheckboxes.removeClass("active");
    const $this = $(this);
    $this.addClass("active");
    const duration = $this.data("duration");
    $courseSelectCards.addClass("d-none");
    $courseSelectCards
      .filter(`#course-select-card-${duration}`)
      .removeClass("d-none");
    if ($checkoutButtonLink.length) {
      $checkoutButtonLink[0].href = `#checkout-button-${duration}`;
    }
    $planSelectRadios.prop("checked", false);
    $this.find(".js-plan-select-radio").prop("checked", true);
    // Do view item list stuff here
  });
}
// END Plan Select

const $iframelyEmbeds = $("[data-oembed-url]");
$iframelyEmbeds.each(function () {
  const $this = $(this);
  const embedUrl = $this.data("oembed-url");
  const urlParts = embedUrl.split(".");
  const extension = urlParts[urlParts.length - 1];

  if (!["mp3", "wav", "m4", "m4a"].includes(extension)) return;

  const audioElement = document.createElement("audio");
  audioElement.setAttribute("controlsList", "nodownload");
  audioElement.setAttribute("controls", undefined);
  audioElement.src = embedUrl;
  audioElement.innerHTML = "Your browser does not support the audio element";

  $this.replaceWith(audioElement);
});

const $questionCompletedNavigation = $(".js-question-completed");
if ($questionCompletedNavigation) {
  const questionResults =
    $questionCompletedNavigation?.data("questions-completed") ?? [];
  const $questionLinks = $questionCompletedNavigation.find(
    ".page-item:not(:first-child) .page-link"
  );
  questionResults?.forEach((isComplete, index) => {
    if (isComplete) {
      const questionLink = $questionLinks
        .toArray()
        .find((questionLink) => questionLink.innerHTML === `${index + 1}`);
      if (!questionLink) return;
      questionLink.classList.add("position-relative");
      questionLink.innerHTML +=
        '<i class="fas fa-check fa-xs position-absolute bottom-0"></i>';
    }
  });
}

const $languageSwitcherLinks = $(".language-switcher-link");
$languageSwitcherLinks.on("click", function (e) {
  const $this = $(this);
  const $languageSwitcher = $this.parent(".language-switcher");
  $languageSwitcher.toggleClass("en");
  $languageSwitcher.toggleClass("ar");
  $languageSwitcherLinks.toggleClass("active");
});
